export default __webpack_public_path__ + "static/media/serf-aircraft.482ab387.jpg";